module.exports = __webpack_public_path__ + "img/ring_0_0_0_1@3x.be596962.png";